// Ensure that a callback is only executed once at a time. State management is
// handled in localStorage.

import { v4 as uuidv4 } from 'uuid';


export const MUTEX_NOT_ACQUIRED = Object('MUTEX_NOT_ACQUIRED');


async function acquireMutex(name, timeout, wait) {
  const id = uuidv4();
  const start = Date.now();
  const mutexValue = id + '|' + start.toString();

  // Covering the wait == 0 case.
  let firstRun = true;

  // Wait for a mutex to be acquired.
  while (start + wait > Date.now() || firstRun) {
    if (firstRun) {
      firstRun = false;
    } else {
      await new Promise(resolve => setTimeout(resolve, 200));
      console.log('try: ', mutexValue);
    }


    // Check if a previous mutex is still valid.
    if (localStorage[name] !== undefined) {
      const [oldId, oldStart] = localStorage[name].split('|');
      const oldStartMs = parseInt(oldStart);
      if (oldStartMs + timeout > start) continue;
    }

    // Ensure there is no race condition.
    localStorage[name] = mutexValue;
    await new Promise(resolve => setTimeout(resolve, 50));
    if (localStorage[name] !== mutexValue) continue;

    return mutexValue;
  }
}

function releaseMutex(name, mutexValue) {
  if (localStorage[name] === mutexValue) delete localStorage[name];
}

export async function localStorageMutex(key, callback, wait = 0, timeout = 120 * 1000) {
  /*
    wait: The maximum time in milliseconds where a mutex is tried to be acquired.
    timeout: The maximum time in milliseconds that a previous mutex can be held.
  */
  const name = 'mutex__' + key;

  const mutexValue = await acquireMutex(name, timeout, wait);
  if (!mutexValue) return MUTEX_NOT_ACQUIRED;

  let response;
  try {
    // Execute the callback.
    response = await callback();
  } finally {
    releaseMutex(name, mutexValue);
  }

  return response;
}
